<template>
  <div class="item row shadow-sm" :data-bol="item.billOfLading">
    <div class="col-3 m-auto">{{ item.billOfLading }}</div>
    <div
      class="col m-auto"
      :title="item.shipper"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ item.shipper }}</div>
    <div
      class="col m-auto"
      :item="item.consignee"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ item.consignee }}</div>
  </div>
</template>

<script>
export default {
  name: 'ContainerWidgetItem',
  props: ['item'],
};
</script>

<style scoped>
.col {
  overflow-x: hidden;
}
</style>
